module.exports = __webpack_public_path__ + "static/media/chevron-droite-medium.9725d290.png";